import { useEffect }   from 'react';
import { SystemEvent } from '../types';

interface UseWindowExitHook {
	removeWindowExitListeners: () => void,
}

// https://dev.to/eons/detect-page-refresh-tab-close-and-route-change-with-react-router-v5-3pd
const useWindowExit = ( confirmExit = false ): UseWindowExitHook => {
	
	/* Method to trigger a prompt */
	const handleBeforeExit = ( event: SystemEvent ): string => {
		
		const e = event || window.event;
		
		if( confirmExit ){
			
			e.preventDefault();
			
			if( e ){
				e[ 'returnValue' ] = '';
			}
			
			return '';
		}
	}
	
	/* Method to trigger the exit handler before unload  */
	const initBeforeUnLoad = () => {
		
		window.addEventListener( 'beforeunload', handleBeforeExit );
	}
	
	/* Registration of method on load */
	window.addEventListener( 'load', initBeforeUnLoad );
	
	/* Set up the effect of sub/unsub */
	useEffect( () => {
		
		initBeforeUnLoad();
		
		return () => {
			
			/* Remove all listeners on unmount */
			removeWindowExitListeners();
		}
		
	} );
	
	const removeWindowExitListeners: UseWindowExitHook['removeWindowExitListeners'] = () => {
		window.removeEventListener( 'beforeunload', handleBeforeExit );
		window.removeEventListener( 'load', initBeforeUnLoad );
	}
	
	return {
		removeWindowExitListeners,
	};
}

export { useWindowExit }
